import routerOptions0 from "/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/Users/dee/Projets/AlezaneFrancoisRobert/Geloso/04_final/sites/geloso.test/app/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}